import type { ClaimCertification } from '../../../store';
import { useClaimCertificationQuery } from '../../../store';

export interface IssueDetailRead {
  certification: ClaimCertification | null;
  /** A read is in flight and nothing has arrived yet. */
  loading: boolean;
}

/**
 * The certification behind an Issues popover (GDN-3379): every finding, not
 * only the row's capped highlights. The Claims tab warms this cache on row
 * hover (`useWorklistRowPrefetch`), so its popover usually opens complete;
 * Home does not, so its popover shows the row at once and appends the rest
 * when the read lands.
 *
 * Called only from content `HoverDetail` renders while open, so a closed
 * row holds no subscription and a list of a hundred rows starts no read
 * until one popover opens.
 */
export const useIssueDetail = (claimId: string): IssueDetailRead => {
  const query = useClaimCertificationQuery({ claimId }, { skip: !claimId });
  return {
    certification: query.currentData ?? null,
    loading: query.isFetching && !query.currentData,
  };
};
